import React, { CSSProperties } from 'react'
import styled from 'styled-components'

import { TPropsToVariant } from '../bootstrapHelper'

const Wrapper = styled.div<{ margin: string | number }>`
  display: flex;
  flex-wrap: wrap;
  margin: -${({ margin }) => margin}px;

  & > * {
    margin: ${({ margin }) => margin}px;
  }
`
export interface TBadgeGroup extends TPropsToVariant {
  children?: React.ReactNode
  margin?: string | number
  className?: string
  style?: CSSProperties
}

const BadgeGroup = (props: TBadgeGroup): React.ReactElement => {
  const { children, margin = '5', className, style, ...rest } = props

  return (
    <Wrapper margin={margin}>
      {React.Children.map(children, (child: React.ReactElement) =>
        React.cloneElement(child, {
          ...rest,
          className,
          style,
        }),
      )}
    </Wrapper>
  )
}

export default BadgeGroup
